import React, { Component } from 'react'
import i18next from 'i18next'

import resultsStyle from './styles/no-results.scss'

import illustration from '../assets/images/wopi-clipped-snap.png'

export default class UnitDetailsWopi360TargetNoResults extends Component {
  render() {
    return (
      <div className={resultsStyle.container}>
        <div>
          <img src={illustration} style={{ width: '100px' }} />

          <h2>{i18next.t('no_results')}</h2>

          <p>{i18next.t('unit_attached_with_wopi360s_will_be_listed_here')}</p>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/UnitDetailsWopi360TargetNoResults.js